import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

export const refreshPageMixin = {
  data () {
    return {
      currentHash: '{{POST_BUILD_ENTERS_HASH_HERE}}',
      hashChanged: false,
      newHash: ''
    }
  },
  methods: {
    initVersionCheck (url, frequency = 60 * 5 * 1000) {
      setInterval(() => {
        this.checkVersion(url + '?t=' + new Date().getTime())
      }, frequency)
    },
    async checkVersion (url) {
      try {
        const fileResponse = await this.axios.get(url)

        this.newHash = fileResponse.data.hash
        this.hashChanged = true

        this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash)

        if (this.hashChanged === true) {
          Swal.fire({
            title: '<h2>Update available !</h2>',
            html: '<p><i class="fas fa-sync"></i>An update is available. Please save all current work and click update below. You can also accept these updates by refreshing your browswer at any time.</h5>' +
              '<p>Not updating may result in errors.</p>',
            confirmButtonText: 'Yes, refresh page!',
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonColor: '#3498db',
            reverseButtons: true,
            icon: 'warning',
            iconHtml: '<i class="fa fa-refresh"></i>',
            preConfirm: () => {
              this.reloadApp()
            }
          })
        }
      } catch (error) {
        this.loading = false
        if (!error.response) {
          this.errorStatus = 'Error: Network Error'
        } else {
          this.errorStatus = error.response.data.message
        }
      }
    },
    hasHashChanged (currentHash, newHash) {
      if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
        return true
      }
      return currentHash !== newHash
    },
    reloadApp () {
      this.currentHash = this.newHash
      window.location.reload()
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.initVersionCheck(process.env.URL + '/version.json')
    }
  }
}



// WEBPACK FOOTER //
// ./src/refresh-page.mixin.js